<!--
 * @Description: 客户激活编辑
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <accountActivationBaseMessage :disabled="false" :permissionPage="permissionBasic" :data="data" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AccountActivationBaseMessage
  from '@/views/overseasSales/customerCenter/accountActivation/components/DetailForm.vue'
import { newClientEvaluationDetail } from '@/api/overseasSales/newClientEvaluation'
const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  let fetchId = -1
  /// 这里判断两次一种是草稿id一种是流程id
  if (route.query.accountActivationId) {
    fetchId = route.query.accountActivationId as unknown as number
  } else if (route.query.draftId) {
    fetchId = route.query.draftId as unknown as number
  }
  newClientEvaluationDetail({ id: fetchId }).then((res) => {
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    data.value = res.data
  })
}
const permissionBasic = {
  save: 'ofbu_potential_edit_btn',
  editCode: 'ofbu_potential_edit_name_or_code_btn'
}
onMounted(() => {
  fetch()
})
</script>
<script lang="ts">
export default { name: 'DcCosOFbuAccountActivationEdit' }
</script>
<style lang="scss" scoped></style>
